<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { close } from '@/components/icons/icons';
import type { RouteLocationRaw } from 'vue-router';
import { useRouter } from 'vue-router';

const props = defineProps<{
  to?: RouteLocationRaw;
  disabled?: boolean;
}>();

const router = useRouter();

function handleClick() {
  if (props.to) {
    router.push(props.to);
  }
}
</script>

<template>
  <Tooltip>
    <template #tooltip>
      {{ $t('Back') }}
    </template>
    <template #target="{ props: tooltipProps }">
      <Button
        v-bind="tooltipProps"
        variant="text"
        :disabled="disabled"
        :icon="close"
        aria-label="Back"
        @click="handleClick"
      />
    </template>
  </Tooltip>
</template>
